import _ from "lodash";
import SupportTicketService from "../provider/SupportTicket/SupportTicketService";
import { SUCCESS, ERROR } from "../common/Util";
import {
	CHANGE_APP_PROPS,
	CHANGE_SUPPORT_TICKET_PROPS
} from "./ActionConstants";

export function actionGetSupportTicketsList(searchText, offset, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetSupportTicketList(searchText, offset, limit).then(response => {
			dispatch({
				type: CHANGE_SUPPORT_TICKET_PROPS,
				props: {
					supportTicketsList: response,
					total: !_.isEmpty(response) ? response[0].cantidad : 0
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetSupportTicketList(searchText, offset, limit) {
	let response = await SupportTicketService.getSupportTicketList(
		searchText,
		offset,
		limit
	);
	return response;
}

export function actionCreateSupportTicket(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		values = formatObjectToJSON(values);
		asyncCreateSupportTicket(values)
			.then(() => callback(SUCCESS))
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncCreateSupportTicket(values) {
	let response = await SupportTicketService.setSupportTicket(values);
	return response;
}

function formatObjectToJSON(values) {
	if (values.supportTicket_type) {
		values.supportTicket_type = { id: values.supportTicket_type };
	}
	return values;
}

export function actionUpdateSupportTicket(supportTicketId, values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		values = formatObjectToJSON(values);
		asyncUpdateSupportTicket(supportTicketId, values)
			.then(response => {
				let supportTicketList = store().supportTicket.supportTicketsList;
				const supportTicketIndex = supportTicketList.findIndex(e => {
					return e.id === response.id;
				});
				supportTicketList[supportTicketIndex] = response;
				dispatch({
					type: CHANGE_SUPPORT_TICKET_PROPS,
					props: {
						supportTicket: response,
						supportTicketsList: supportTicketList
					}
				});
				callback(SUCCESS);
			})
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				})
			);
	};
}

async function asyncUpdateSupportTicket(supportTicketId, values) {
	let response = await SupportTicketService.updateSupportTicket(
		supportTicketId,
		values
	);
	return response;
}

export function actionDeleteSupportTicket(supportTicketId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteSupportTicket(supportTicketId)
			.then(() => callback(SUCCESS))
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncDeleteSupportTicket(supportTicketId) {
	let response = await SupportTicketService.deleteSupportTicket(
		supportTicketId
	);
	return response;
}

export function actionChangeSupportTicketProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_SUPPORT_TICKET_PROPS,
			props: props
		});
	};
}
export function actionGetUsersSupportList() {
	return dispatch => {
		// dispatch({
		// 	type: CHANGE_APP_PROPS,
		// 	props: {
		// 		loading: true
		// 	}
		// });
		asyncGetUsersSupport().then(response => {
			dispatch({
				type: CHANGE_SUPPORT_TICKET_PROPS,
				props: {
					usersSupportList: response
				}
			});
			// dispatch({
			// 	type: CHANGE_APP_PROPS,
			// 	props: {
			// 		loading: false
			// 	}
			// });
		});
	};
}

async function asyncGetUsersSupport() {
	let response = await SupportTicketService.getUsersSupport();
	return response;
}



// WEBPACK FOOTER //
// ./src/actions/SupportTicketActions.js